/* © CNES */
import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ConfigContext } from '../../context/ConfigContext';
import { AppHeader } from '../appHeader/AppHeader';
import { PageHeader } from '../shared/PageHeader/PageHeader';
import { DownloadProgressDialog } from '../shared/Toast/DownloadProgressDialog';
import { JobsCompletedToast } from '../shared/Toast/JobsCompletedToast';
import './MyData.scss';
import { MyDataTabs } from './MyDataTabs/MyDataTabs';

/**
 * MyData Page.
 * @returns Element
 */
export const MyData = () => {
  const context = useContext(ConfigContext);
  const isAuthDisabled = process.env.NODE_ENV !== 'production';
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const contextRef = useRef(context);
  contextRef.current = context;
  const [downloadProgress, setDownloadProgress] = useState<number | null>(null);

  /**
   * When user click on link in JobsCompletedToast,
   * Change index to view the processings list and then remove child path from url.
   */
  useEffect(() => {
    if (window.location.href.includes('processings')) {
      setActiveIndex(1);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      const context = contextRef.current;
      if (!isAuthDisabled && !context.userLoggedIn.email) {
        navigate({
          pathname: '/',
        });
      }
    }, 2000);
    // eslint-disable-next-line
  }, [isAuthDisabled, context]);

  return (
    <>
      <AppHeader tabindex={1} />
      <div className="MyDataContainer">
        <PageHeader pageTitle="My Data" isMyDataPage={true} />
        <MyDataTabs
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
          setDownloadProgress={setDownloadProgress}
        />
      </div>
      <JobsCompletedToast />
      <DownloadProgressDialog downloadProgress={downloadProgress} />
    </>
  );
};
